import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "row mb-10",
  style: {"align-items":"flex-end"}
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "mb-10" }
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_text = _resolveComponent("input-text")!
  const _component_drop_down = _resolveComponent("drop-down")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass({ 'col-7-md' : !_ctx.large, 'col-8-md' : _ctx.large })
      }, [
        _createVNode(_component_input_text, {
          "input-type": "text",
          name: _ctx.fieldNames.postcode,
          modelValue: _ctx.address.postcode,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.address.postcode) = $event)),
          label: "Postcode",
          placeholder: "Postcode",
          small: !_ctx.large,
          "validation-state": _ctx.validationState.postcode,
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getStreets(false)))
        }, null, 8 /* PROPS */, ["name", "modelValue", "small", "validation-state"])
      ], 2 /* CLASS */),
      _createElementVNode("div", {
        class: _normalizeClass({ 'col-5-md' : !_ctx.large, 'col-4-md' : _ctx.large })
      }, [
        _createElementVNode("button", {
          class: _normalizeClass(["button button--ghost button--full mb-20", { 'button--small' : ! _ctx.large}]),
          type: "button",
          disabled: _ctx.loadingStreet || _ctx.disableLookup,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getStreets(false)))
        }, " Lookup ", 10 /* CLASS, PROPS */, _hoisted_2)
      ], 2 /* CLASS */)
    ]),
    (_ctx.streets.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_drop_down, {
              modelValue: _ctx.houseId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.houseId) = $event)),
              name: "houseId",
              options: _ctx.streetOptions,
              label: "Address",
              small: !_ctx.large,
              loading: _ctx.loadingAddress,
              onChange: _ctx.getAddress
            }, null, 8 /* PROPS */, ["modelValue", "options", "small", "loading", "onChange"])
          ], 512 /* NEED_PATCH */), [
            [_vShow, !_ctx.manual]
          ]),
          _createElementVNode("p", _hoisted_4, [
            (!_ctx.manual)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "#",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleManual && _ctx.toggleManual(...args)), ["prevent","stop"]))
                }, "If your address isn't listed, you can manually input it here"))
              : _createCommentVNode("v-if", true),
            (_ctx.manual)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: "#",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleManual && _ctx.toggleManual(...args)), ["prevent","stop"]))
                }, "Back to selecting your address from the list"))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _withDirectives(_createElementVNode("div", null, [
      (_ctx.notFound)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, " We haven't found any addresses for that postcode please enter your details manually. "))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_input_text, {
        "input-type": "text",
        name: _ctx.fieldNames.address1,
        modelValue: _ctx.address.address1,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.address.address1) = $event)),
        label: "Address 1",
        placeholder: "Address 1",
        small: !_ctx.large,
        "validation-state": _ctx.validationState.address1
      }, null, 8 /* PROPS */, ["name", "modelValue", "small", "validation-state"]),
      _createVNode(_component_input_text, {
        "input-type": "text",
        name: _ctx.fieldNames.address2,
        modelValue: _ctx.address.address2,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.address.address2) = $event)),
        label: "Address 2",
        placeholder: "Address 2",
        small: !_ctx.large,
        "validation-state": _ctx.validationState.address2
      }, null, 8 /* PROPS */, ["name", "modelValue", "small", "validation-state"]),
      _createVNode(_component_input_text, {
        "input-type": "text",
        name: _ctx.fieldNames.address3,
        modelValue: _ctx.address.address3,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.address.address3) = $event)),
        label: "Address 3",
        placeholder: "Address 3",
        small: !_ctx.large,
        "validation-state": _ctx.validationState.address3
      }, null, 8 /* PROPS */, ["name", "modelValue", "small", "validation-state"]),
      _createVNode(_component_input_text, {
        "input-type": "text",
        name: _ctx.fieldNames.town,
        modelValue: _ctx.address.town,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.address.town) = $event)),
        label: "Town",
        placeholder: "Town",
        small: !_ctx.large,
        "validation-state": _ctx.validationState.town
      }, null, 8 /* PROPS */, ["name", "modelValue", "small", "validation-state"]),
      _createVNode(_component_input_text, {
        "input-type": "text",
        name: _ctx.fieldNames.county,
        modelValue: _ctx.address.county,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.address.county) = $event)),
        label: "County",
        placeholder: "County",
        small: !_ctx.large,
        "validation-state": _ctx.validationState.county
      }, null, 8 /* PROPS */, ["name", "modelValue", "small", "validation-state"])
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.manual]
    ])
  ]))
}